import { apiFetch } from "@/lib/api";

export const SUNTRONIC_BOX_LABELS_QUERY_KEY = ["manufacturing", "suntronic-box-labels"] as const;

export interface SuntronicBoxLabelLineRow {
  batch_id: number;
  batch_item_id: number;
  date_created: string;
  mfr_ship_by_date: string | null;
  manufacturer_sales_order_number: string | null;
  sku: string;
  order_quantity: number;
  quantity_shipped: number;
  default_print_quantity: number;
  issued_count: number;
  remaining_print_quantity: number;
  fully_shipped: boolean;
  bar_code_model: string | null;
  bar_code_model_ready: boolean;
}

export interface SuntronicBoxLabelIssuedSerialRow {
  serial_number: string;
  issued_at: string;
}

export interface SuntronicBoxLabelListResponse {
  lines: SuntronicBoxLabelLineRow[];
}

export interface SuntronicBoxLabelLineResponse {
  line: SuntronicBoxLabelLineRow;
  serials: SuntronicBoxLabelIssuedSerialRow[];
}

export interface SuntronicBoxLabelPreviewResponse {
  serial_number: string;
  finished_sku: string;
  zpl: string;
  png_base64: string;
  preview_dpi: number;
}

export interface SuntronicBoxLabelPrintResponse {
  printed: boolean;
  printed_count: number;
  total_count: number;
  serials: string[];
}

function linePath(batchItemId: number): string {
  return `/api/manufacturing/suntronic-box-labels/lines/${String(batchItemId)}`;
}

export function fetchSuntronicBoxLabelLines(): Promise<SuntronicBoxLabelListResponse> {
  return apiFetch<SuntronicBoxLabelListResponse>("/api/manufacturing/suntronic-box-labels");
}

export function fetchSuntronicBoxLabelLine(batchItemId: number): Promise<SuntronicBoxLabelLineResponse> {
  return apiFetch<SuntronicBoxLabelLineResponse>(linePath(batchItemId));
}

export function fetchSuntronicBoxLabelPreview(input: {
  batchItemId: number;
  printer?: string;
}): Promise<SuntronicBoxLabelPreviewResponse> {
  const params = new URLSearchParams();
  if (input.printer != null && input.printer.trim() !== "") {
    params.set("printer", input.printer.trim());
  }
  const query = params.toString();
  return apiFetch<SuntronicBoxLabelPreviewResponse>(
    `${linePath(input.batchItemId)}/preview${query === "" ? "" : `?${query}`}`,
  );
}

export function printSuntronicBoxLabels(input: {
  batchItemId: number;
  printer: string;
  quantity: number;
}): Promise<SuntronicBoxLabelPrintResponse> {
  return apiFetch<SuntronicBoxLabelPrintResponse>(`${linePath(input.batchItemId)}/print`, {
    method: "POST",
    body: { printer: input.printer, quantity: input.quantity },
  });
}

export function reprintSuntronicBoxLabels(input: {
  batchItemId: number;
  printer: string;
}): Promise<SuntronicBoxLabelPrintResponse> {
  return apiFetch<SuntronicBoxLabelPrintResponse>(`${linePath(input.batchItemId)}/reprint`, {
    method: "POST",
    body: { printer: input.printer },
  });
}
